import $ from 'jquery';
import ClubStore from 'framework/stores/ClubStore';
import ProfileStore from 'framework/stores/ProfileStore';
import profileStoreIsAvailable from 'lib/profile-store-utils';

let moxieData = {};
moxieData.ltf_WebsiteURL = window.location.href;

function updateClubData(clubData){
	if(clubData.id) {
		moxieData.ltf_webCLUBID = clubData.id;
		moxieData.ltf_webCLUBState = clubData.stateName;
	}
}

function updateProfileData(profileData){
	if(profileData.memberDetails && profileData.memberDetails.memberId){
		moxieData.ltf_MemberNumber = profileData.memberDetails.memberId;
	}
}

function updateMoxieChannelsData(){
	window.GoMoxie.conciergeV2.channelsData(moxieData);
}

$(() => {
	let conciergeReady = new Promise(function(resolve, reject) {
		window.addEventListener('GoMoxie:conciergeReady', resolve);
	});

	conciergeReady.then(function() {
		updateClubData(ClubStore.getInitialData());
        if (profileStoreIsAvailable) {
            updateProfileData(ProfileStore.getInitialData());
        }
		updateMoxieChannelsData();

		ClubStore.listen((club) => {
			updateClubData(club);
			updateMoxieChannelsData();
		});

		window.addEventListener('GoMoxie:widget:chat:chatSessionEnded', updateMoxieChannelsData, false);
	});
});
